import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import UnitKerjaRepository from '../Repositories/UnitKerjaRepository'

class UnitKerjaBloc
{
    repository = new UnitKerjaRepository()
    unitkerjaDataTableChannel = new Subject()
    unitkerjaSubmitChannel = new Subject()
    unitkerjaDeleteChannel = new Subject()
    unitkerjaActivateChannel = new Subject()

    constructor() {
        this.unitkerjaDataTableChannel.next({status: apiResponse.INITIAL})
        this.unitkerjaSubmitChannel.next({status: apiResponse.INITIAL})
        this.unitkerjaDeleteChannel.next({status: apiResponse.INITIAL})
        this.unitkerjaActivateChannel.next({status: apiResponse.INITIAL})
    }

    fetchDataTable = async (query, cancelToken) => {
        this.unitkerjaDataTableChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDataTable(query, cancelToken).then((result) => {
            this.unitkerjaDataTableChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.unitkerjaDataTableChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchSubmit = async (query) => {
        this.unitkerjaSubmitChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchSubmit(query).then((result) => {
            this.unitkerjaSubmitChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.unitkerjaSubmitChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchDelete = async (query) => {
        this.unitkerjaDeleteChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDelete(query).then((result) => {
            this.unitkerjaDeleteChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.unitkerjaDeleteChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchActivate = async (query) => {
        this.unitkerjaActivateChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchActivate(query).then((result) => {
            this.unitkerjaActivateChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.unitkerjaActivateChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
   

}

export default UnitKerjaBloc